import { z } from 'zod';
/**
 * App-Release-Contracts (ADR-051). Native App-Versionen, die der Admin hochlädt;
 * die App vergleicht beim Start ihren versionCode mit `latest`.
 */
export const appReleaseDtoSchema = z.object({
    id: z.string().uuid(),
    platform: z.string(),
    versionCode: z.number().int(),
    versionName: z.string(),
    notes: z.string().nullable(),
    sizeBytes: z.number().int(),
    publishedAt: z.string().nullable(), // null = Entwurf (nicht freigegeben)
    createdAt: z.string(),
});
export const latestReleaseResponseSchema = z.object({
    release: appReleaseDtoSchema.nullable(), // neueste FREIGEGEBENE Version
    canUpload: z.boolean(), // true nur für das Admin-Konto (darf hochladen/freigeben)
});
/** Admin-Übersicht aller Releases (freigegebene + Entwürfe). */
export const releaseListResponseSchema = z.object({
    releases: z.array(appReleaseDtoSchema),
});
/** Upload-Metadaten (versionName als semver X.Y.Z; notes optional). */
export const createReleaseSchema = z.object({
    versionName: z.string().regex(/^\d+\.\d+\.\d+$/, 'Version als X.Y.Z'),
    notes: z.string().max(2000).optional(),
});
/**
 * versionName „1.2.3" → monotoner versionCode. MUSS mit der Formel in
 * `apps/web/android/app/build.gradle` (ADR-046) übereinstimmen, damit der
 * Start-Vergleich stimmt: major*1_000_000 + minor*1_000 + patch.
 */
export function versionCodeFromName(versionName) {
    const parts = versionName.split('.').map((n) => Number.parseInt(n, 10) || 0);
    const maj = parts[0] ?? 0;
    const min = parts[1] ?? 0;
    const pat = parts[2] ?? 0;
    return maj * 1_000_000 + min * 1_000 + pat;
}
//# sourceMappingURL=app-release.js.map